var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeneralContent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    id: "svg3096",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3217",
    style: {
      stroke: "#fff",
      strokeWidth: 0
    },
    d: "m 12,3 a 9,9 0 0 0 -9,9 9,9 0 0 0 9,9 9,9 0 0 0 9,-9 9,9 0 0 0 -9,-9 z M 8.484375,8.1914062 h 7.03125 v 1.7578126 h -4.6875 v 0.5859372 c 0,2.031248 0.976564,3.181641 2.929687,3.451172 v -1.107422 h -1.171874 v -1.757812 h 2.929687 v 4.6875 h -0.785156 c -3.773434,0 -5.6601565,-1.757816 -5.6601565,-5.273438 V 9.9492188 H 8.484375 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "none"
    },
    d: "m 15.515625,15.808594 h -0.785156 q -5.6601565,0 -5.6601565,-5.273438 V 9.9492188 H 8.484375 V 8.1914063 h 7.03125 v 1.7578125 h -4.6875 v 0.5859372 q 0,3.046875 2.929688,3.451172 v -1.107422 h -1.171875 v -1.757812 h 2.929687 z",
    id: "text1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralContent);
export default __webpack_public_path__ + "static/media/general-content.0ffe10e8d5a2c0c474c3d63b05853527.svg";
export { ForwardRef as ReactComponent };